import { asyncThunkCreator, buildCreateSlice } from '@reduxjs/toolkit'

/**
 * Enhanced Redux slice creator with async thunk support.
 *
 * Creates a Redux slice builder that includes support for async thunks,
 * providing a more convenient way to create slices with async actions.
 * This is a configured version of Redux Toolkit's buildCreateSlice.
 *
 * @example
 * ```typescript
 * const userSlice = createAppSlice({
 *   name: 'user',
 *   initialState: { data: null, loading: false },
 *   reducers: create => ({
 *     // Regular reducers
 *     setUser: create.reducer((state, action) => {
 *       state.data = action.payload
 *     }),
 *
 *     // Async thunk
 *     fetchUser: create.asyncThunk(
 *       async (userId: string) => {
 *         const response = await api.getUser(userId)
 *         return response.data
 *       },
 *       {
 *         pending: state => { state.loading = true },
 *         fulfilled: (state, action) => {
 *           state.loading = false
 *           state.data = action.payload
 *         },
 *         rejected: state => { state.loading = false }
 *       }
 *     )
 *   })
 * })
 * ```
 */
export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
})
